import{jsxs as o,jsx as r}from"react/jsx-runtime";import{useState as e,useRef as t,useEffect as a,cloneElement as n,isValidElement as i}from"react";import m from"tailwind-styled-components";import l from"clsx";import{getAnimationIn as s,getAnimationOut as d,getTransformOrigin as p}from"../utils.js";import c from"../../hooks/use-placement.js";import u from"../animate/animate.js";const f=m.div`
  outline-none
  relative
`,b=m.div`
  absolute
  bg-white
  border-t
  border-t-gray-50
  min-w-[15em]
  outline-none
  p-4
  rounded
  shadow-md
  shadow-brand-primary/20
  z-10

  dark:bg-gray-700
  dark:border-t-gray-800
  dark:text-gray-300
  dark:shadow-black/40
`,g=({children:m,className:g,isOpen:h,placement:y="bottom-left",trigger:k,...w})=>{const[x,j]=e(!1),v=t(null),O=c(y),C=o=>()=>{"boolean"!=typeof h&&setTimeout((()=>{j(!x)}),x?250:0),"function"==typeof o&&o()};return a((()=>{x&&"boolean"!=typeof h&&setTimeout((()=>{v?.current?.focus()}),250)}),[x,v,h]),a((()=>{"boolean"==typeof h&&j(h)}),[h]),o(f,{...w,children:[n(k,{...i(k)?k.props:{},"aria-haspopup":!0,"aria-expanded":x,onClick:C(k.props.onClick)}),r(u,{animationIn:s(y),animationOut:d(y),transformOrigin:p(y),visible:h||x,children:r(b,{className:l(O,g),onBlur:C(),ref:v,role:"dialog",tabIndex:"-1",children:m})})]})};export{g as Dropdown,g as default};
